import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { sportsHelpers } from "projectSpecific/sports/cnr/reducers/reducerHelpers/sportsHelpers";
import { _sportsOriginTypes } from "projectSpecific/sports/cnr/reducers/SportsReducer";
import { useCallback, useContext } from "react";
import { DatabaseContext } from "../../../global/cnr/contexts/DatabaseContext";
import { _showAppLogs } from "../../../global/cnr/contexts/LogContext";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";
import { useCacheDataManager } from "../../../global/cnr/contexts/useHelpers/cacheDataManager";
import { useMultiDoc } from "../../../global/cnr/contexts/useHelpers/useMultiDoc";
import { AppTimestampContext } from "global/cnr/contexts/AppTimestampContext";
import { seasonalHelpers } from "../cnr/reducers/reducerHelpers/seasonalHelpers";
import { shouldUseCache } from "global/cnr/contexts/useHelpers/useHelpers";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { TimestampsContext } from "../../../global/cnr/contexts/TimestampsContext";

export const _logcons = {
  // ♻️ recycleGreen
  // ⚠️ alter
  // ⚡lightning
  // ✅ checkGreen 
  // ✔️ check
  // ❌ delete
  // ➡️ arrowRight
  // ⬆️ arrowUp
  // ⬇️ arrowDown
  // ⬛ Black
  // ⬜ White
  // 🌐 web
  // 🎨 pallette
  // 👇 pointerDown
  // 👉 pointerLeft
  // 💡 bulb
  // 💾 database
  // 📁 folder
  // 📝 note
  // 📡???
  // 📦 box
  // 🔁 recycleBlue
  // 🔄 recycleRound
  // 🔍 magnify
  // 🔑 key
  // 🔒 lock
  // 🔥 fire
  // 🔹 diamond
  // 🗄️cacheFile
  // 🧠 brain
  // 😄 smile
  // 🙂 smileEyes
  // 🚨 siren
  // 🚫 Ban
  // 🟥 Red
  // 🟦 Blue
  // 🟧 Orange
  // 🟨 Yellow
  // 🟩 Green
  // 🟪 Purple
  // 🟫 Brown
  // 1️⃣ one
  // 2️⃣ two
  // 3️⃣ three
  // ⏰ alarm
  // 🕒 clockfase
  // ⏱️ stopwatch
  // 🕰️ mantle
  // 🕒time
  // 🌐 web
  // 🔀 difference / divergence / branching
  // ↔️ comparison between two things
  // ⚖️ contrast / balance / distinction
  // 🆚 versus / opposing sides
  // ➖ subtraction / delta / reduction
  // 📏 measurement difference
  // 🔍 spot the difference
  // ◀️▶️ separation between two states
  // 🧩 mismatch / pieces differing
  // 🔄 changed from previous state
  // ✅ official / confirmed
  // 🏛️ governing body / sanctioned
  // 📋 official record
  // 🧾 verified documentation
  // 🛡️ certified / authorized
  // ✔️ approved
  // 🔒 locked/finalized
  // 📣 officially announced
  // ⏳ pending
  // 🕒 waiting
  // ⌛ processing
  // 🟡 pending/attention
  // 🔄 in progress
  // 📨 awaiting response
  // 💤 inactive/waiting
  red: '🟥',

}

export const _matchSeasonalCollection = 'matches_seasonal'

const dataItems_organization = {
  schools: { collectionName: 'schools' },
}

const dataItems_district = {
  gls_access: { collectionName: 'gls_access', noYear: true, noListen: true, appUsersOnly: true },
  gls_district: { collectionName: 'gls_district', noYear: true, noListen: true, appUsersOnly: true },
  gls_scores: { collectionName: 'gls_scores', noYear: true, noListen: true, appUsersOnly: true },
  schools_district: { renderAs: 'schools', collectionName: 'schools_district', collectionDocField: 'schools', noListen: true },
  sports: { collectionName: 'sports', noYear: true, noListen: false },
  // teams_sport: { collectionName: 'teams_sport', noYear: true, noListen: false },
  sportsAccess_district: { collectionName: 'sportsAccess_district', noYear: true, noListen: true, appUsersOnly: true },
  sportsAccess_schools: { renderAs: 'schools', collectionName: 'sportsAccess_schools', collectionDocField: 'schools', noYear: true, noListen: true, appUsersOnly: true },
  sportsAccess_sports: { renderAs: 'sports', collectionName: 'sportsAccess_sports', collectionDocField: 'sports', noYear: true, noListen: true, appUsersOnly: true },
}

const dataItems_sportsSeason = {
  gls_teams: { collectionName: 'gls_teams', noYear: true, noListen: true, appUsersOnly: true },
  history: { collectionName: 'history', noYear: true, noListen: true },
  mediaFeeds: { collectionName: 'mediaFeeds', sportPropName: 'mediaFeeds', noListen: true },
  rankings_seasonal: { collectionName: 'rankings_seasonal', collectionDocField: 'rankings', noListen: true },
  playoffs: { collectionName: 'playoffs', sportPropName: 'playoffs', noListen: true },
  seasonals: { collectionName: 'seasonals', sportPropName: 'seasonals', noListen: true },
  sportsAccess_teams: { collectionName: 'sportsAccess_teams', noYear: true, noListen: true, appUsersOnly: true },
  teamRosters_seasonal: { collectionName: 'teamRosters_seasonal', collectionDocField: 'teamRosters', noListen: true, sportPropName: 'teamRosters' },
  teams_seasonal: { collectionName: 'teams_seasonal', sportPropName: 'teams_seasonal', collectionDocField: 'teams', noListen: true, ignoreCache: true },
  teamStaff: { collectionName: 'teamStaff', noListen: true },
  tournaments: { collectionName: 'tournaments', noListen: true },
  teams_sport: { collectionName: 'teams_sport', noYear: true, noListen: false },
  videoUrls: { collectionName: 'videoUrls', sportPropName: 'videoUrls', noListen: true },
}

const _applyCache = true
const _showLogs = true

export const _sportsInfoTypes = {
  organizations: 'organizations',
  districts: 'districts',
  sportsSeason: 'sportsSeason',
  sportsSeasonResults: 'sportsSeasonResults',
}

export const useSportsInfo = ({ sportsInfoType }) => {

  const cache_groupType = sportsInfoType + 'Info';

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { sports: sportsKey } = pathViews ?? {}

  // appTimestampContext
  const appTimestampContext = useContext(AppTimestampContext);
  const { appTimestamp_state } = appTimestampContext ?? {}
  const { timestampInfo } = appTimestamp_state ?? {}
  const { timestamps } = timestampInfo ?? {}

  // timestampsContext
  const timestampsContext = useContext(TimestampsContext)
  const { timestamps_state } = timestampsContext ?? {}
  const { _validatedTimestamps } = timestamps_state ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const { handleGet_multiDocs, handleGet_multiDocs_noListen } = useMultiDoc()
  const cdm = useCacheDataManager()

  const getSportMode = (sport) => {
    if (sport) {
      const _smk = _.camelCase(sport.name)
      const sportsSeasonInfo = sportsHelpers.getSportSeasonType(_smk)
      return sportsSeasonInfo
    }
    return {}
  }

  const handle_organizationInfo = async ({ organization, organizationData, callback, fromCache, newTimestamp }) => {
    const _organizationtData = unwrapObject(organizationData, dataItems_organization)
    const organizationInfo = { ..._organizationtData, organization }
    _showAppLogs.sportInfo && isAdminOrSuper && console.log(`✅${fromCache ? '🗄️' : '🔥'}${sportsInfoType}`, organizationInfo)
    // add the data to cache
    if (!fromCache) {
      const fullData = { organization, organizationData: _organizationtData }
      await cdm.mergeToGroup(cache_groupType, organization._itemKey, fullData, newTimestamp, true);
    }
    callback(organizationInfo)
  }

  const handle_districtInfo = async ({ district, districtData, callback, fromCache, newTimestamp }) => {
    const _districtData = unwrapObject(districtData, dataItems_district)
    const districtInfo = { ..._districtData, district }
    _showAppLogs.sportInfo && isAdminOrSuper && console.log(`✅${fromCache ? '🗄️' : '🔥'}${sportsInfoType}`, districtInfo)
    // add the data to cache 
    if (!fromCache) {
      const fullData = { district, districtData: _districtData }
      await cdm.mergeToGroup(cache_groupType, district._itemKey, fullData, newTimestamp, true);
    }
    callback(districtInfo)
  }

  const handle_sportsInfo = async ({ sport, sportData, callback, fromCache, newTimestamp }) => {
    const _sportData = unwrapObject(sportData, dataItems_sportsSeason)
    const sportInfo = { ..._sportData, sport, sportMode: getSportMode(sport), _validatedTimestamp: newTimestamp }
    _showAppLogs.sportInfo && isAdminOrSuper && console.log(`✅${fromCache ? '🗄️' : '🔥'}${sportsInfoType}`, sportInfo)
    // add the data to cache
    if (!fromCache) {
      const fullData = { sport, sportData: _sportData }
      await cdm.mergeToGroup(cache_groupType, sport._itemKey, fullData, newTimestamp, true);
    }
    callback(sportInfo)
  }

  /**
   * handles the data from the organizations document
   * @param {*} organization 
   * @param {*} cb_main 
   */
  const handleDbData_sportsOrganization = (organization, cb_main, newTimestamp) => {
    const cb = async (organizationData) => {
      _showLogs && console.log('🔥organization', organization)
      _showLogs && console.log('🔥organizationData', organizationData)
      handle_organizationInfo({ organization, organizationData, callback: cb_main, fromCache: false, newTimestamp })
    }
    const _pks = seasonalHelpers.getPks(pathViews, null, null, ['sports', 'teams'])
    // handleGet_multiDocs({ key: 'sportsInfo', sportsDocs: dataItems_organization, pathViews, pks: _pks, callback: cb })
    handleGet_multiDocs_noListen({ key: 'sportsInfo', sportsDocs: dataItems_organization, pathViews, pks: _pks, callback: cb })
  }

  /**
   * handles the data from the districts document
   * @param {*} district 
   * @param {*} cb_main 
   */
  const handleDbData_sportsDistrict = (district, cb_main, newTimestamp) => {
    const cb = async (districtData) => {
      _showLogs && console.log('🔥district', district)
      _showLogs && console.log('🔥districtData', districtData)
      handle_districtInfo({ district, districtData, callback: cb_main, fromCache: false, newTimestamp })
    }
    const _pks = seasonalHelpers.getPks(pathViews, null, null, ['sports', 'teams'])
    // handleGet_multiDocs({ key: 'sportsInfo', sportsDocs: dataItems_district, pathViews, pks: _pks, callback: cb })
    handleGet_multiDocs_noListen({ key: 'sportsInfo', sportsDocs: dataItems_district, pathViews, pks: _pks, callback: cb })
  }

  /**
   * handles the data from the sports document
   * @param {*} sport 
   * @param {*} cb_main 
   */
  const handleDbData_sportsSeason = (sport, cb_main, newTimestamp) => {
    const { latestSeason } = sport ?? {}
    const cb = async (sportData, parentDataKeys) => {
      _showLogs && console.log('🔥sport', sport)
      _showLogs && console.log('🔥sportData', sportData)
      handle_sportsInfo({ sport, sportData, parentDataKeys, callback: cb_main, fromCache: false, newTimestamp })
    }
    const _pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['sports', 'teams'])
    // handleGet_multiDocs({ key: 'sportsInfo', sportsDocs: dataItems_sportsSeason, pathViews, pks: _pks, callback: cb })
    handleGet_multiDocs_noListen({ key: 'sportsInfo', sportsDocs: dataItems_sportsSeason, pathViews, pks: _pks, callback: cb })
  }

  const unwrapObject = (obj, sportDoc) =>
    _.transform(obj, (acc, value, key) => {
      const sd = sportDoc?.[key]
      const { renderAs } = sd ?? {}
      const _key = renderAs || key
      acc[key] = _.get(value, _key, value)
    }, {})

  const getSportInfoData = useCallback((_sportsInfoType, callback) => {

    const cgt = _sportsInfoType + 'Info';

    const cb_data = (data, newTimestamp) => {
      switch (_sportsInfoType) {
        case _sportsInfoTypes.organizations:
          handleDbData_sportsOrganization(data, callback, newTimestamp)
          break;

        case _sportsInfoTypes.districts:
          handleDbData_sportsDistrict(data, callback, newTimestamp)
          break;

        case _sportsInfoTypes.sportsSeason:
          handleDbData_sportsSeason(data, callback, newTimestamp)
          break;
      }
    }

    const cb_cache = (cachedData) => {
      switch (_sportsInfoType) {
        case _sportsInfoTypes.organizations:
          handle_organizationInfo({ ...cachedData, callback })
          break;

        case _sportsInfoTypes.districts:
          handle_districtInfo({ ...cachedData, callback })
          break;

        case _sportsInfoTypes.sportsSeason:
          handle_sportsInfo({ ...cachedData, callback })
          break;
      }
    }

    // depending on the _sportsInfoType, get the ata
    switch (_sportsInfoType) {
      case _sportsInfoTypes.organizations:
        getItemData(_sportsInfoType, cdm, timestamps, cgt, pathViews, pathViews.organizations, 'organizations', true, database_fns, cb_cache, cb_data, _validatedTimestamps)
        break;

      case _sportsInfoTypes.districts:
        getItemData(_sportsInfoType, cdm, timestamps, cgt, pathViews, pathViews.districts, 'districts', true, database_fns, cb_cache, cb_data, _validatedTimestamps)
        break;

      case _sportsInfoTypes.sportsSeason:
        getItemData(_sportsInfoType, cdm, timestamps, cgt, pathViews, sportsKey, 'sports', false, database_fns, cb_cache, cb_data, _validatedTimestamps)
        break;
    }
  }, [])

  return { getSportInfoData }

}

const getItemData = async (
  sportsInfoType,
  cdm,
  timestamps,
  cgt,
  pathViews,
  pathKey,
  collectionName,
  ignoreId,
  database_fns,
  callback_cache,
  callback_data,
  _validatedTimestamps,
) => {

  const currentTimestamp_db = timestamps?.[cgt]?.[pathKey];

  // get the cache
  const cache_result = await cdm.getSubItem(cgt, pathKey);
  const { _timestamp: timestamp_cache } = cache_result ?? {}

  // 🛑 KEY GUARD: already have this version 
  const validatedTimestamp = _validatedTimestamps?.[cgt] ?? {};

  if (validatedTimestamp && validatedTimestamp === currentTimestamp_db) {
    _showAppLogs.sportInfo && console.log(`✅🚫${cgt}`)
    // return; // 🚫 do nothing
  }

  const allowCache = shouldUseCache(timestamp_cache, currentTimestamp_db, cgt)
  let hasCacheData

  switch (sportsInfoType) {
    case _sportsInfoTypes.organizations:
      _showLogs && console.log('✅🗄️cache_result🗄️', sportsInfoType, cache_result)
      hasCacheData = cache_result?.organization && cache_result?.organizationData ? true : false
      break;

    case _sportsInfoTypes.districts:
      _showLogs && console.log('✅🗄️cache_result🗄️', sportsInfoType, cache_result)
      hasCacheData = cache_result?.district && cache_result?.districtData ? true : false
      break;

    case _sportsInfoTypes.sportsSeason:
      _showLogs && console.log('✅🗄️cache_result🗄️', sportsInfoType, cache_result)
      hasCacheData = cache_result?.sport && cache_result?.sportData ? true : false
      break;
  }

  // return the cache data if available
  if (_applyCache && !_.isEmpty(cache_result) && allowCache && hasCacheData) {
    callback_cache({ ...cache_result, fromCache: true, newTimestamp: currentTimestamp_db })
    return;
  }

  // get the data from the database
  const _refPath = createRefPath_event(pathViews, [collectionName, pathKey])
  database_fns.get_doc({ refPath: _refPath, opts: { ignoreId: ignoreId }, callback: callback_data })

} 